import "./App.css";
import React, { Suspense, lazy } from "react";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider, useLocation } from "react-router-dom";
import router from "./routes.jsx";
import FloatingIconWithPopup from "./Components/FloatingIconWithPopup/FloatingIconWithPopup.jsx";
function App() {
 
  return (
    <div>
      <Suspense fallback={<></>}>
        <RouterProvider router={router} />
      </Suspense>
      <FloatingIconWithPopup />
    </div>
  );
}

export default App;
